import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
require("./init/index");

import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primevue/resources/primevue.css";
import "primevue/resources/themes/bootstrap4-light-purple/theme.css";
import "./assets/sass/app.scss";
import Password from "primevue/password";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import ProgressSpinner from "primevue/progressspinner";
import Menubar from "primevue/menubar";
import Breadcrumb from "primevue/breadcrumb";
import Sidebar from "primevue/sidebar";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import PrimeVue from "primevue/config";
import Dialog from "primevue/dialog";
import Panel from "primevue/panel";
import Card from "primevue/card";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import Toast from "primevue/toast";
import InputMask from "primevue/inputmask";
import ConfirmPopup from "primevue/confirmpopup";
import Fieldset from "primevue/fieldset";
import Menu from "primevue/menu";
import Textarea from "primevue/textarea";
import Editor from "primevue/editor";
import OverlayPanel from "primevue/overlaypanel";
import Tooltip from "primevue/tooltip";
import BlockUI from "primevue/blockui";
import { AuthImage } from "@/directives/AuthImage";

const app = createApp(App)
  .use(PrimeVue)
  .use(store)
  .use(router)
  .use(ToastService)
  .use(ConfirmationService)
  .use(i18n);
app.directive("tooltip", Tooltip);
app.directive("auth-image", AuthImage);
app.component("Dialog", Dialog);
app.component("Panel", Panel);
app.component("Card", Card);
app.component("Password", Password);
app.component("InputText", InputText);
app.component("Button", Button);
app.component("Checkbox", Checkbox);
app.component("ProgressSpinner", ProgressSpinner);
app.component("Toast", Toast);
app.component("Menubar", Menubar);
app.component("Breadcrumb", Breadcrumb);
app.component("Sidebar", Sidebar);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("Dropdown", Dropdown);
app.component("InputMask", InputMask);
app.component("ConfirmPopup", ConfirmPopup);
app.component("Fieldset", Fieldset);
app.component("Menu", Menu);
app.component("Textarea", Textarea);
app.component("Editor", Editor);
app.component("OverlayPanel", OverlayPanel);
app.component("BlockUI", BlockUI);

app.mount("#app");
